import { combineReducers } from 'redux';

import textEditing from './textEditing/reducer';
import emojis from './emojis/reducer';
import subject from './subject/reducer';

export default combineReducers({
  textEditing,
  emojis,
  subject
});



/** WEBPACK FOOTER **
 ** ./src/members/state/feedback/reducer.js
 **/